import { RootState } from 'store';

export const selectors = {
  selectMnemonicCardsPacks: (state: RootState) => state.mnemonicCardsPacks.mnemonicCardsPacks,
  selectMnemonicCardsMeta: (state: RootState) => state.mnemonicCardsPacks.meta,
  selectMnemonicCardPackId: (state: RootState) => state.mnemonicCardsPacks.currentPackId,
};
